import type { IconProps } from "./icon-types";

/**
 * 휴지통(delete). Modal 헤더 액션 / 리스트 항목 삭제 등에서 사용.
 *
 * 글리프는 sigmakit-gui가 쓰는 `react-icons/lu`의 `LuTrash2`(Lucide `trash-2`)를
 * 인라인으로 재현한 것 — c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * Lucide 원본 그대로 24 그리드 / strokeWidth 2 / round cap·join 유지.
 */
export const TrashIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M3 6h18" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
  </svg>
);
